import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { CompanyDetail, CompanyRefreshResponse, Rankings } from '../models/company.model';

@Injectable({ providedIn: 'root' })
export class CompanyService {
  private readonly api = inject(ApiService);

  getCompanyDetail(cui: string): Observable<CompanyDetail> {
    return this.api.get<CompanyDetail>(`/companies/${cui}`);
  }

  refreshCompany(cui: string): Observable<CompanyDetail> {
    return this.api.postToData<CompanyRefreshResponse>(`/companies/${cui}/refresh`).pipe(
      map(res => ({ ...res.company, courtCases: res.courtCases })),
    );
  }

  refreshRankings(cui: string): Observable<Rankings[]> {
    return this.api.post<Rankings[]>(`/companies/${cui}/rankings/refresh`);
  }
}
